export default {
      id: "4-arrow-up-usage",
      viewBox: "0 0 270 165",
      url: __webpack_public_path__ + "svg/sprite.svg#4-arrow-up",
      toString: function () {
        return this.url;
      }
    }